import { ChangeEvent, MutableRefObject } from 'react';
import styled from 'styled-components';

interface NakedInputProps {
  type: 'text' | 'number';
  placeholder: string;
  inputValue?: string | number;
  isButton?: boolean;
  isEditable?: boolean;
  onChange?: (newValue: string | number | undefined) => void;
  onClick?: () => void;
  inputRef: MutableRefObject<HTMLInputElement | null>;
  textAlign?: 'left' | 'right';
}

export const NakedInput = ({
  type,
  placeholder,
  inputValue,
  onChange,
  isButton = false,
  isEditable = true,
  onClick,
  inputRef,
  textAlign = 'right',
}: NakedInputProps) => {
  return (
    <Input
      type={type}
      inputMode={type === 'number' ? 'numeric' : 'text'}
      placeholder={placeholder}
      value={inputValue}
      onChange={(event: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
          onChange(event.target.value || undefined);
        }
      }}
      readOnly={isButton || !isEditable}
      usePointer={isButton}
      greyColor={!isEditable}
      ref={inputRef}
      textAlign={textAlign}
      onClick={onClick}
    />
  );
};

const Input = styled.input<{ usePointer: boolean; greyColor: boolean; textAlign: 'left' | 'right' }>`
  width: 100%;
  height: 21px;
  max-height: 21px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  text-align: ${(props) => props.textAlign};

  overflow: hidden;

  color: ${(props) => (props.greyColor ? '#858894' : '#232429')};

  text-overflow: ellipsis;
  white-space: nowrap;

  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */

  border: none;

  caret-color: #196eff;

  cursor: ${(props) => props.usePointer && 'pointer'};

  padding: 0px;

  background-color: transparent;

  &::placeholder {
    overflow: hidden;
    color: var(--Light-Scheme-Monochrome-grey70, #a7a9b6);
    text-overflow: ellipsis;
    white-space: nowrap;

    /* Display/Large/l-regular */
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%; /* 20.8px */
  }

  :focus {
    outline-offset: 0px;
    --tw-ring-shadow: none;
  }

  :is(:focus, :valid, :read-only) {
    border: 0px;
    outline: 0;
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
